<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="4">DADOS {{ !isPolicy ? 'DA APÓLICE' : 'DO ENDOSSO' }}</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>N° Apólice:</b>
          {{
            formatPolicyNumber(
              !isPolicy
                ? previousPolicy.policyNumber
                : quotationData.policyNumber,
            )
          }}
        </td>
        <td class="pl-3">
          <b>N° Endosso:</b>
          {{ !isPolicy ? '' : quotationData.proposal_id }}
        </td>
        <td class="pl-3">
          <b>N° Proposta:</b>
          {{
            formatProposalNumber(
              !isPolicy
                ? previousPolicy.proposalNumber
                : quotationData.proposal_id,
            )
          }}
        </td>
        <td class="pl-3">
          <b>Data {{ !isPolicy ? 'da Apólice' : 'do Endosso' }}:</b>
          {{
            functions.formatDateAndHour(
              !isPolicy
                ? previousPolicy.subscriptionDate
                : proposalData.dataAdesao,
              true,
            )
          }}
        </td>
      </tr>
      <tr>
        <td v-if="isPolicy" class="pl-3" colspan="2">
          <b>Tipo: </b>{{ operationType }}
        </td>
        <td class="pl-3" :colspan="!isPolicy ? 4 : 2">
          <b>Vigência{{ !isPolicy ? ' da Apólice' : '' }}: </b>24:00 de
          {{
            functions.formataDataHoraPadraoBR(
              !isPolicy
                ? previousPolicy.startDate
                : proposalData.inicioVigencia,
              false,
            )
          }}
          até 24:00 de
          {{
            functions.formataDataHoraPadraoBR(
              !isPolicy ? previousPolicy.endDate : proposalData.fimVigencia,
              false,
            )
          }}
        </td>
      </tr>
      <tr>
        <td class="pl-3" colspan="2"><b>Seguradora: </b>BP SEGURADORA</td>
        <td class="pl-3"><b>CNPJ: </b>50.180.527/0001-13</td>
        <td class="pl-3"><b>SUSEP: </b>{{ SUSEP_CODE.BP_SEGURADORA }}</td>
      </tr>
      <tr>
        <td colspan="2" class="pl-3"><b>Ramo: </b>05.31 - Automóvel</td>
        <td class="pl-3" colspan="1">
          <div>
            <b>Classe de bônus:</b>
            {{ !isPolicy ? previousPolicy.bonus : proposalData.bonus.bonus }}
          </div>
        </td>
        <td class="pl-3" colspan="1">
          <div>
            <b>CI:</b>
            {{ previousPolicy.ci }}
          </div>
        </td>
      </tr>
    </table>
    <div
      v-if="
        !isPolicy
          ? customSectionsMsgs.DATA_ENDORSEMENT_PREVIOUS_POLICY
          : customSectionsMsgs.DATA
      "
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="
        !isPolicy
          ? customSectionsMsgs.DATA_ENDORSEMENT_PREVIOUS_POLICY
          : customSectionsMsgs.DATA
      "
    ></div>
  </vx-card>
</template>

<script>
import { SUSEP_CODE } from '../../../constants/susep.code.enum';
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractPolicyData',
  props: {
    isPolicy: {
      type: Boolean,
      required: false,
      default: false,
    },
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    operationType: {
      type: String,
      required: false,
      default: '',
    },
    previousPolicy: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
      SUSEP_CODE,
    };
  },
  methods: {
    formatPolicyNumber(policyNumber) {
      if (!policyNumber) {
        return '';
      }

      return this.functions.formatStarNumber(
        policyNumber,
        this.proposalData.idTipoApolice,
        'POLICY',
      );
    },
    formatProposalNumber(proposalNumber) {
      if (!proposalNumber) {
        return '';
      }

      return functions.formatStarNumber(
        proposalNumber,
        this.proposalData.idTipoApolice,
        'PROPOSAL',
      );
    },
  },
};
</script>
